import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import SecondaryButton from './Assets/SecondaryButton';
import aboutUsImg from './images/about-us-img.jpg';
import './Assets/LandingRoute.css';

function AboutUs() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isMobile = window.innerWidth <= 768;
  const slideRightClass = isMobile ? '' : scrollPosition > 950 ? 'aboutSlide-right show' : 'aboutSlide-right';
  const slideLeftClass = isMobile ? '' : scrollPosition > 950 ? 'aboutSlide-left show' : 'aboutSlide-left';

  return (
    <Container
      id="about"
      disableGutters
      maxWidth="lg"
      sx={{
        px: {
          xs: 2,
          sm: 5,
          md: 3.5,
        },
        my: 5,
      }}
    >
      <Box sx={{ marginBottom: 0 }}>
        <h1>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: '600',
              fontSize: '26px',
              lineHeight: '48px',
              color: '#161414',
              textAlign: {
                xs: 'center',
              },
            }}
          >
            About Us
          </Typography>
        </h1>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          justifyContent: 'center',
          gap: 4,
          alignItems: 'center',
        }}
      >
        <Box sx={{ flex: 1 }} className={slideLeftClass}>
          <Typography
            variant="body1"
            color="text.secondary"
            paragraph
            fontSize={isMobile ? '1rem' : '1.2rem'}
            mt={3}
          >
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
              At <strong>InnoWave API Hub</strong>, powered by <strong>Tylect Technologies Pvt Ltd</strong>, we are dedicated to providing
              efficient, reliable, and scalable API solutions for businesses of all sizes.
              Our <strong>seamless API management</strong> ensures that integrations remain up to date, accessible, and
              hassle-free, empowering businesses to focus on <strong>growth</strong> without <strong>technical complexities</strong>.
            </Typography>
            <br />
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
              With a <strong>pay-per-use pricing model</strong> based on <strong>per-hit charges</strong>, we offer a <strong>flexible</strong> and
              <strong> cost-effective solution</strong> for businesses needing dependable, on-demand API access—without the burden
              of large upfront investments. Our platform simplifies API usage, allowing businesses to scale effortlessly
              while keeping costs <strong>predictable</strong> and <strong>manageable</strong>.
            </Typography>

          </Typography>
          <SecondaryButton text="Go to About Page" to="/about" />
        </Box>
        <Box sx={{ flex: 1 }} className={slideRightClass}>
          <img
            src={aboutUsImg}
            alt="About Us"
            title="Learn more about us"
            width={500}
            height={300}
            loading="lazy"
            style={{
              borderRadius: '24px',
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}

export default AboutUs;
